<!-- Monitoreo -->
<div class="subgrupo">
  <h2>Monitoreo</h2>

  <!-- Nombre App monitoreo -->
  <mat-form-field [formGroup]="configuracion">
    <mat-label>Nombre de la App de Monitoreo</mat-label>
    <input
      matInput
      placeholder="Centro de Monitoreo de Watson"
      formControlName="nombreAppMonit"
    />
  </mat-form-field>

  <!-- Ver Actualizaciones -->
  <div class="mb-3" [formGroup]="configuracion">
    <mat-checkbox
      formControlName="verActualizaciones"
      style="margin-bottom: 1em"
    >
      Ver Actualizaciones de Firmware
    </mat-checkbox>
  </div>

  <!-- Ver Sucesos -->
  <div class="mb-3" [formGroup]="configuracion">
    <mat-checkbox
      formControlName="verSucesos"
      style="margin-bottom: 1em"
    >
      Ver Sucesos
    </mat-checkbox>
  </div>

  <!-- Offline como Online -->
  <div class="mb-3" [formGroup]="configuracion">
    <mat-checkbox formControlName="verSirenasOnline"
      >Ver Sirenas Offline como Online</mat-checkbox
    >
  </div>

  <!-- Reenviar a Tito -->
  <div class="mb-3" [formGroup]="configuracion">
    <mat-checkbox
      formControlName="reenviarATito"
      style="margin-bottom: 1em"
    >
      Reenviar eventos a Tito
    </mat-checkbox>
  </div>
</div>

<!-- Eventos Externos -->
@if (mostrarEventos) {
<div class="subgrupo">
  <h2>Eventos Externos</h2>

  <!-- Activar sirena -->
  <ng-container [formGroup]="configuracion">
    <mat-checkbox formControlName="activarSirena">
      Activar sirena cercana
    </mat-checkbox>
    <div class="row-center" style="gap: 8px">
      <section class="layout">
        <div class="grow1">
          <ng-select
            placeholder="Alerta"
            formControlName="alertaEventoExterno"
            appendTo="body"
          >
            @for (b of botones; track b._id) {
              <ng-option [value]="b._id"
                >{{ b.nombre }} ({{ b.variante }})</ng-option
              >
            }
          </ng-select>
        </div>
      </section>
    </div>
  </ng-container>
</div>

<!-- Eventos Bluetooth -->
<div class="subgrupo">
  <h2>Eventos Bluetooth</h2>

  <!-- Activar sirena -->
  <ng-container [formGroup]="configuracion">
    <mat-checkbox formControlName="activarSirenaBle">
      Activar sirena cercana
    </mat-checkbox>
    <div class="row-center" style="gap: 8px">
      <section class="layout">
        <div class="grow1">
          <ng-select
            placeholder="Alerta"
            formControlName="alertaEventoExternoBle"
            appendTo="body"
          >
            @for (b of botones; track b._id) {
              <ng-option [value]="b._id"
                >{{ b.nombre }} ({{ b.variante }})</ng-option
              >
            }
          </ng-select>
        </div>
      </section>
    </div>
  </ng-container>
</div>
}

<!-- Integración SOFLEX -->
<div class="subgrupo">
  <h2>Integración SOFLEX</h2>

  <ng-container [formGroup]="configuracion">
    <!-- Habilitar integración -->
    <div class="mb-3">
      <mat-checkbox formControlName="integracionSOFLEX">
        Habilitar integración con SOFLEX
      </mat-checkbox>
    </div>

    <!-- Configuración de conexión (solo si está habilitada) -->
    @if (integracionSOFLEX) {
      <div [formGroup]="configSOFLEX">
        <h4 class="mb-2">Configuración de Conexión</h4>

        <div class="mb-3">
          <!-- URL -->
          <mat-form-field style="width: 100%">
            <mat-label>URL de la API SOFLEX</mat-label>
            <input
              matInput
              formControlName="url"
              placeholder="https://api.soflex.com"
              required
            />
          </mat-form-field>
        </div>

        <div class="grid-cols-2 mb-3">
          <!-- Usuario -->
          <mat-form-field style="width: 100%">
            <mat-label>Usuario</mat-label>
            <input matInput formControlName="user" required />
          </mat-form-field>

          <!-- Contraseña -->
          <mat-form-field style="width: 100%">
            <mat-label>Contraseña</mat-label>
            <input
              matInput
              type="password"
              formControlName="password"
              required
            />
          </mat-form-field>
        </div>

        <h4 class="mb-2 mt-3">Configuración de Fleet</h4>

        <div class="grid-cols-3 mb-3">
          <!-- Provider ID -->
          <mat-form-field style="width: 100%">
            <mat-label>Provider ID</mat-label>
            <input matInput formControlName="providerid" required />
          </mat-form-field>

          <!-- Fleet ID -->
          <mat-form-field style="width: 100%">
            <mat-label>Fleet ID</mat-label>
            <input matInput formControlName="fleetid" required />
          </mat-form-field>

          <!-- Fleet Name -->
          <mat-form-field style="width: 100%">
            <mat-label>Fleet Name</mat-label>
            <input matInput formControlName="fleetName" required />
          </mat-form-field>
        </div>

        <h4 class="mb-2 mt-3">Configuración de Reintentos</h4>

        <div class="grid-cols-2 mb-3">
          <!-- Máximo reintentos -->
          <mat-form-field style="width: 100%">
            <mat-label>Máximo de Reintentos</mat-label>
            <input
              matInput
              type="number"
              formControlName="maxReintentos"
              min="1"
              max="10"
            />
            <mat-hint>Entre 1 y 10 intentos</mat-hint>
          </mat-form-field>

          <!-- Tiempo entre reintentos -->
          <mat-form-field style="width: 100%">
            <mat-label>Tiempo entre Reintentos (ms)</mat-label>
            <input
              matInput
              type="number"
              formControlName="tiempoEntreReintentos"
              min="1000"
            />
            <mat-hint
              >Tiempo base en milisegundos (mínimo 1000)</mat-hint
            >
          </mat-form-field>
        </div>
      </div>
    }
  </ng-container>
</div>

<!-- Integración IRIX -->
<div class="subgrupo">
  <h2>Integración IRIX</h2>

  <ng-container [formGroup]="configuracion">
    <!-- Habilitar integración -->
    <div class="mb-3">
      <mat-checkbox formControlName="integracionIRIX">
        Habilitar integración con IRIX
      </mat-checkbox>
    </div>

    <!-- Configuración de conexión (solo si está habilitada) -->
    @if (integracionIRIX) {
      <div [formGroup]="configIRIX">
        <h4 class="mb-2">Configuración de Integración</h4>

        <div class="mb-3">
          <!-- URL -->
          <mat-form-field style="width: 100%">
            <mat-label>URL de la API IRIX</mat-label>
            <input
              matInput
              formControlName="url"
              placeholder="https://api.irix.ar/gestion-sirenas-test"
              required
            />
          </mat-form-field>
        </div>

        <div class="mb-3">
          <!-- Apikey -->
          <mat-form-field style="width: 100%">
            <mat-label>Apikey</mat-label>
            <input matInput formControlName="apikey" required />
          </mat-form-field>
        </div>
      </div>
    }
  </ng-container>
</div>
